// extracted by mini-css-extract-plugin
module.exports = {"text":"SubscriptionMessage_text__ivLD_"};